import { RAID_CONTROL_ATTACK_LIMIT } from '../domain/raidControlMemberAttacks.js';

// 닉네임 옆 "남은 타수 / 3" - 아직 안 쓴 멤버가 3/3, 다 쓴 멤버가 0/3이다.
// 집계를 아직 못 쓰는 동안(attackCount가 null)에는 아무것도 그리지 않는다.
export function RaidControlMemberAttackBadge({ member }) {
  const limit = Number(member?.attackLimit) || RAID_CONTROL_ATTACK_LIMIT;
  const count = member?.attackCount;
  if (count === null || count === undefined) return null;
  const used = Math.max(0, Math.min(limit, Number(count) || 0));
  const remaining = limit - used;
  // 색은 진행도를 따른다 - 다 쓴 멤버가 is-done, 한 타도 안 쓴 멤버가 is-none이다.
  const className = `raid-control-member-attacks ${remaining <= 0 ? 'is-done' : remaining < limit ? 'is-partial' : 'is-none'}`;
  return <em className={className} title={`${limit}타 중 ${remaining}타 남음`}>{remaining}/{limit}</em>;
}
